<text-logo class={style.textLogo}>
  <script>
   import style from './text-logo.scss';
   this.style = style;
  </script>
</text-logo>
